import React from "react";

const LocationIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
                d="M16.6667 8.33366C16.6667 12.4945 12.0508 16.8278 10.5008 18.1662C10.3564 18.2747 10.1807 18.3335 10 18.3335C9.81934 18.3335 9.64357 18.2747 9.49917 18.1662C7.94917 16.8278 3.33334 12.4945 3.33334 8.33366C3.33334 6.56555 4.03571 4.86986 5.28596 3.61961C6.5362 2.36937 8.23189 1.66699 10 1.66699C11.7681 1.66699 13.4638 2.36937 14.714 3.61961C15.9643 4.86986 16.6667 6.56555 16.6667 8.33366Z"
                stroke="#364153"
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10 10.833C11.3807 10.833 12.5 9.71372 12.5 8.33301C12.5 6.9523 11.3807 5.83301 10 5.83301C8.61929 5.83301 7.5 6.9523 7.5 8.33301C7.5 9.71372 8.61929 10.833 10 10.833Z"
                stroke="#364153"
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default LocationIcon;
